// src/pages/BusinessLandingPage.jsx
import React, { useState, useEffect } from 'react';
import './BusinessLandingPage.css';

import BHeader from '../components/business_landing/BHeader';
import BHero from '../components/business_landing/BHero';
import BSpacyHub from '../components/business_landing/BSpacyHub';
import BRoi from '../components/business_landing/BRoi';
import BDashboard from '../components/business_landing/BDashboard';
import BTeachers from '../components/business_landing/BTeachers';
import BCases from '../components/business_landing/BCases';
import BClients from '../components/business_landing/BClients';
import BImplementation from '../components/business_landing/BImplementation';
import BContact from '../components/business_landing/BContact';
import BWhatsapp from '../components/business_landing/BWhatsapp';
import BFooter from '../components/business_landing/BFooter';

function BusinessLandingPage() {

  // === 🩹 CIRUGÍA 1: Leer el tema guardado del localStorage ===
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    // === 🩹 CIRUGÍA 2: Guardar el tema en localStorage al cambiar ===
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="business-landing-page-wrapper">
      
      <BHeader 
        onScrollTo={scrollToSection}
        onToggleTheme={toggleTheme}
        themeIcon={theme === 'dark' ? '☀️' : '🌙'}
      />
      
      <main>
        <BHero onScrollTo={scrollToSection} />

        {/* --- CONEXIÓN DE PROP --- */}
        <BSpacyHub id="spacy" onScrollTo={scrollToSection} /> 
        
        <BRoi id="roi" /> 
        <BDashboard id="dashboard" />
        <BTeachers id="teachers" />
        <BCases id="cases" />
        <BClients />
        <BImplementation id="implementation" /> 
        <BContact id="contact" />
      </main>
      <BWhatsapp />
      <BFooter />
    </div>
  );
}

export default BusinessLandingPage;